import { ReviewTrucksContentWrapper } from "../ReviewTrucksPage/ReviewTrucksPage.styles.ts";
import {
	ExportConfirmationText,
	ReturnToTruckOrdersButtonText,
	ThankYouTruckSubmittedSubheader
} from "constants/text.ts";
import ReviewTruckDetails from "components/Trucks/components/ReviewTruckDetails/ReviewTruckDetails.tsx";
import ReviewTruckStopOrderCard from "components/Trucks/components/ReviewTruckStopOrderCard/ReviewTruckStopOrderCard.tsx";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "stores/application.store.tsx";
import useHandlePopState from "hooks/useHandlePopState.ts";
import { truckActions } from "features/reducers/truck/truck.ts";
import ExportButtons from "components/ExportFile/ExportButtons.tsx";
import { generateTruckConfirmationPageExcel } from "components/Trucks/helpers/TruckConfirmationExportHelper.ts";
import { TruckThankYouHeader } from "./TruckConfirmationPage.styles.ts";
import { NewOrderThanksHeader } from "components/NewOrders/constants.ts";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import StopDetails from "components/Trucks/components/StopDetails/StopDetails.tsx";
import SupportCTA from "components/Common/SupportCTA/SupportCTA";
import { getSupportFormUrl } from "utils/supportForm";

const TrucksConfirmationPage = () => {
	const dispatch = useDispatch();
	const navigateTo = useNavigate();
	const storedTruck = useSelector((state: RootState) => state.truck.truck);
	const firstDraftOrder = storedTruck?.stops?.flatMap((stop) => stop.draftOrders ?? []).find(Boolean);
	const supportFormUrl = getSupportFormUrl({
		type: "Order Help",
		brand: firstDraftOrder?.configurations?.[0]?.globals?.brand?.description,
		poNumber: firstDraftOrder?.poNumber
	});
	const handleBackToTrucks = () => {
		dispatch(truckActions.clearTruck());
		navigateTo("/trucks");
	};

	useHandlePopState({
		title: "Truck Confirmation",
		path: "/trucks",
		dispatchActions: () => {
			dispatch(truckActions.clearTruck());
		}
	});

	return (
		<div>
			<TruckThankYouHeader>
				<div>
					<h5>{NewOrderThanksHeader}</h5>
					<div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
						<SupportCTA
							href={supportFormUrl}
							data-testid="trucks-confirmation-support-button"
							sx={{ height: 30 }}
						/>
						<ExportButtons
							largePDF={false}
							buttonHeader={ExportConfirmationText}
							generateExcel={() =>
								storedTruck ? generateTruckConfirmationPageExcel(storedTruck) : Promise.resolve()
							}
							isOnlyExcel
						/>
					</div>
				</div>
				<div>{ThankYouTruckSubmittedSubheader}</div>
				<Button
					variant="contained"
					onClick={handleBackToTrucks}
					data-testid="new-order-confirmation-details-button"
					data-id="trucks-return-to-my-orders-button"
				>
					{ReturnToTruckOrdersButtonText}
				</Button>
			</TruckThankYouHeader>
			<ReviewTrucksContentWrapper data-testid="review-trucks-content-wrapper">
				<ReviewTruckDetails data-testid="review-truck-details" />
				{storedTruck?.stops?.map((stop, index) => (
					<div
						key={stop.truckStopId}
						data-testid={`truck-stop-${index}`}
					>
						<StopDetails
							stop={stop}
							index={index}
						/>
						{stop.draftOrders?.map((order, orderIndex) =>
							order.configurations?.map((configuration, configIndex) => (
								<ReviewTruckStopOrderCard
									data-testid={`review-truck-stop-order-card-${index}-${orderIndex}-${configIndex}`}
									key={`${orderIndex}-${configIndex}`}
									configuration={configuration}
									address={stop.address}
									shipToAddress={order.shipToAddress}
									poNumber={order.poNumber}
									designerNumber={order.designerNumber}
									jobName={order.jobName}
									labelComments={order.labelComments}
								/>
							))
						)}
					</div>
				))}
			</ReviewTrucksContentWrapper>
		</div>
	);
};
export default TrucksConfirmationPage;
